import t from"styled-components";import{theme as i}from"../../../../theme.js";const n=t.div`
  position: sticky;
  z-index: 10;
  bottom: 0;
  right: 0;
  background-color: ${i.colors.shades[0]};
  width: 100%;
  box-sizing: border-box;
  padding: ${i.spacing*4}px;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-areas: "additional buttons";
  grid-column-gap: ${i.spacing*4}px;
  align-items: center;
  border-radius: 0 0 6px 6px;
  @media screen and (max-width: ${i.breakpoints.md}) {
    display: none;
  }
`,o=t.div`
  display: flex;
  gap: ${i.spacing*4}px;
  justify-content: flex-end;
  grid-area: buttons;
`;export{o as ButtonsContainer,n as Container};
